module.exports = __webpack_public_path__ + "static/media/Vimeo.727f9be0.svg";